import React, {useEffect} from 'react';

import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';

import error403 from './settings/error403';
import error500 from './settings/error500';
import Error404 from './settings/error404';
import login from './users/login';
import CentralLogin from './users/central_login';
import LogOut from './users/logout';
import forgotpassword from './users/forgotpassword';
import ProtectedView from './protected_view'
import {LicenseTimeout} from './component/notify'
import {  LocalUrl, PortalType, reset_password } from './component/include';
import recover_password from './users/recover_password';
import Template from './component/template';
import StaffTemplate from './staff_portal/component/template';
import MyPassword from './users/MyPassword';

const App =()=>{

  /* 
const checkLicense=()=>{
//prevent working from localhost
if(window.location.hostname ==='localhost'){
    return false;
 }else{
    return true;
  }
}

useEffect(()=>{
setTimeout(() => {
if(checkLicense()===false){
  document.getElementById('openLicenseModal').click()
//timeup logout user
}
}, 4000)
}, []) */

    // Function to check if user needs password reset
    const needsPasswordReset = () => {
      return reset_password === 'Yes' && PortalType === 'Admin';
    };

    return (<>
    <a href="#!" data-toggle="modal" id='openLicenseModal' data-target='#licenseModal' ></a>
    <LicenseTimeout /> 
      <ReactNotification />
     <Router>
      <Switch>
        {/* Public routes that don't require authentication */}
        <Route exact path="/" component={CentralLogin} />
        <Route exact path="/logout" component={LogOut} />
        <Route exact path="/forgot_password" component={forgotpassword} />
        <Route exact path="/recover_password" component={recover_password} />
        
        {/* Direct route to password reset page */}
        <Route exact path="/staff/my_password" component={MyPassword} />

        {/* Protected routes with conditional rendering based on portal type */}
        {PortalType === 'Admin' ? (
          <Route path="/">
            {needsPasswordReset() ? <Redirect to="/staff/my_password" /> : <Template />}
          </Route>
        ) : (
          <StaffTemplate />
        )}
        
        {/* Catch all route for 404 errors */}
        <Route component={Error404} />
      </Switch>
      </Router>
 </>
    );
  
}
export default App;
